module.exports = __webpack_public_path__ + "419425202a4652fde137202b0f8f1900.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/trees/branch-green.png
// module id = 3481
// module chunks = 0